import ApiService from "@/core/services/api.service";
import querystring from 'querystring';
import moment from "moment";
import {LARAVEL_DATE_FORMAT, LARAVEL_DATE_TIME_FORMAT, MOMENT_SYSTEM_DATE_FORMAT} from "@/core/config/constant";

// getter types
export const ERROR = 'SAMPLE/ERROR';
export const ITEMS = 'SAMPLE/ITEMS';
export const ITEM = 'SAMPLE/ITEM';
export const LOADING = 'SAMPLE/LOADING';
export const PAGE_NUMBER = 'SAMPLE/PAGE_NUMBER';
export const PER_PAGE = 'SAMPLE/PER_PAGE';
export const SAMPLE_ITEMS = 'SAMPLE/SAMPLE_ITEMS';
export const START_DATE = 'SAMPLE/START_DATE';
export const END_DATE = 'SAMPLE/END_DATE';
export const STATUS = 'SAMPLE/STATUS';
export const SEARCH = 'SAMPLE/SEARCH';
export const ACTIVE_NAV = 'SAMPLE/ACTIVE_NAV';

// mutation types
export const DELETE_ITEM = "SAMPLE/M/LOG_OUT";
export const SET_ITEM = "SAMPLE/M/SET_ITEM"; // setUser
export const SET_ERROR = "SAMPLE/M/SET_ERROR";
export const SET_LOADING = "SAMPLE/M/SET_LOADING";
export const SET_ITEMS = "SAMPLE/M/SET_ITEMS";
export const SET_PAGE_NUMBER = "SAMPLE/M/SET_PAGE_NUMBER";
export const SET_PER_PAGE = "SAMPLE/M/SET_PER_PAGE";
export const SET_START_DATE = "SAMPLE/M/SET_START_DATE";
export const SET_END_DATE = "SAMPLE/M/SET_END_DATE";
export const SET_STATUS = "SAMPLE/M/SET_STATUS";
export const SET_SEARCH = "SAMPLE/M/SEARCH";
export const SET_ACTIVE_NAV = "SAMPLE/M/ACTIVE_NAV";

// action types
export const STORE = "SAMPLE/A/STORE";
export const LIST = "SAMPLE/A/LIST";
export const GET = "SAMPLE/A/GET";
export const DELETE = "SAMPLE/A/DELETE";
export const UPDATE = "SAMPLE/A/UPDATE";
export const RESET_FILTERS = "SAMPLE/A/RESET_FILTERS";


const state = {
  error: null,
  items: {},
  item: {},
  loading: false,
  pageNumber: 1,
  perPage: 3,
  startDate: moment().day(-30),
  endDate: moment(),
  status: null,
  search: '',
  activeNav: null,
};

const getters = {
  [ITEM]:  state => {
    return state.item;
  },
  [ITEMS]: state => {
    return state.items;
  },
  [LOADING]: (state) => {
    return state.loading;
  },
  [ERROR]: state => {
    return state.perPage;
  },
  [PAGE_NUMBER]: state => {
    return state.pageNumber;
  },
  [PER_PAGE]: state => {
    return state.perPage;
  },

  [START_DATE]: state => {
    return state.startDate;
  },
  [END_DATE]: state => {
    return state.endDate;
  },
  [STATUS]: state => {
    return state.status;
  },
  [SEARCH]: state => {
    return state.status;
  },
  [ACTIVE_NAV]: state => {
    return state.activeNav;
  },
  [SAMPLE_ITEMS]: state => {
    let items = [];
    for(let key in state.items.data){
      items.push({
        'product_image': `<img src="${state.items.data[key].product.image}" style="width: 100px; height: 100px; object-fit:cover;">`,
        'product_name': state.items.data[key].product.name,
        'order_date': moment(state.items.data[key].order_date, LARAVEL_DATE_FORMAT).format(MOMENT_SYSTEM_DATE_FORMAT),
        'collection_number': state.items.data[key].collection_number,
        'customer_name': state.items.data[key].company.name,
        'deadline': moment(state.items.data[key].deadline, LARAVEL_DATE_FORMAT).format(MOMENT_SYSTEM_DATE_FORMAT),
        'model': state.items.data[key].model_name,
        'amount': state.items.data[key].amount,
        'model_description': state.items.data[key].model_description,
        'status': state.items.data[key].sample_status.name,
      });
    }
    return items;
  },

};

const mutations = {
  [SET_LOADING](state, payload) {
    state.loading = payload;
  },
  [SET_ERROR](state, payload) {
    state.error = payload;
  },

  [SET_ITEMS](state, payload) {
    state.items = payload;
  },
  [SET_PAGE_NUMBER](state, payload) {
    state.pageNumber = payload;
  },
  [SET_PER_PAGE](state, payload) {
    state.perPage = payload;
  },
  [SET_START_DATE](state, payload) {
    state.startDate = payload;
  },
  [SET_END_DATE](state, payload) {
    state.endDate = payload;
  },
  [SET_STATUS](state, payload) {
    state.status = payload;
  },
  [SET_SEARCH](state, payload) {
    state.search = payload;
  },
  [SET_ACTIVE_NAV](state, payload) {
    state.activeNav = payload;
  },

};

const actions = {
  [RESET_FILTERS](context){
    context.commit(SET_SEARCH, '');
    context.commit(SET_START_DATE, moment().day(-30));
    context.commit(SET_END_DATE, moment());
    context.commit(SET_STATUS, null);
  },
  [GET](context) {
    context.commit(SET_LOADING, true);
    // I will add more filter options here,so, let name this as filters for now as well
    let filters = {
      page_number: context.state.pageNumber,
      per_page: context.state.perPage,
      start_date: context.state.startDate.format(LARAVEL_DATE_TIME_FORMAT),
      end_date: context.state.endDate.format(LARAVEL_DATE_TIME_FORMAT),
      status: context.state.status,
      search: context.state.search,
      sample_type_id: context.state.activeNav
    };
    ApiService.get("api/samples?" + querystring.stringify(filters)).then((response ) => {
      context.commit(SET_LOADING, false);
      context.commit(SET_ITEMS, response.data);
    }).catch((error) => {
      context.commit(SET_LOADING, false);
      context.commit(SET_ERROR, error);
    });
  }
};



export default {
  state,
  actions,
  mutations,
  getters
};
